export default {

	//API_URL: 'http://kanbanapi.pro-react.com';    //original value
	ENABLE_CACHE: true,
	STOREAGE_KEY: 'aaedb',
	API_HOST: 'https://www.culvers.com',            //reads from MVC app
	MENU_FLAVORS_ENDPOINT : "v2/svcMenu/getgroups",
	PROMOTION_ENTRY_URI: "/lucky7",
	HEADERS: { 'Content-Type': 'application/json', "Accept": 'application/json' },
	FACEBOOK_APP_ID: '583250808520580',
	LOGGED_OUT_USER:{
		FirstName: '',
		LastName: '',
		PostalCode: '',
		FavoriteLocations: [],
		EclubSubscriptions: [],
		TextClubSubscriptions: [],
		FamilyMembers: [],
		PreferredFlavors: [],
		LoggedIn: false,
		isUpdated: false, // Don't use "Updated" it's a datestamp
		errors: {},
		UserName: '',
		Email: '',
		loading: false,
		Birthdate: '',
		BirthDay: '',
		BirthMonth: '',
		GlobalEmailOptOut: false,
		PhoneNumber: ''
	},
	BUDGET_BASE: {
		errors: {},
		selectedValue: null,
		selectedValues: [],
		selectedSliderIndex: null,
		selectedGridIndex: null,
		visited: false
	}
};



// WEBPACK FOOTER //
// ./src/constants.js